import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../pages/AuthContext';
import { motion, AnimatePresence } from 'framer-motion';
import API_BASE_URL from '../config/api';
const fadeUp = { hidden: { opacity: 0, y: 28 }, show: { opacity: 1, y: 0, transition: { duration: 0.6 } } };
const stagger = { show: { transition: { staggerChildren: 0.12 } } };

/* â”€â”€ Shared Components â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
const SectionLabel = ({ children, light = false }) => (
  <p style={{ fontFamily: 'Poppins, sans-serif', fontSize: '0.68rem', fontWeight: 700, letterSpacing: '0.28em', textTransform: 'uppercase', color: light ? 'rgba(212,175,55,0.8)' : '#D4AF37', marginBottom: '0.75rem' }}>{children}</p>
);

const SectionHeading = ({ children, light = false, center = false }) => (
  <h2 style={{ fontFamily: '"Cormorant Garamond", "Playfair Display", serif', fontSize: 'clamp(2rem, 4vw, 3.2rem)', fontWeight: 700, lineHeight: 1.2, color: light ? 'white' : '#16213E', marginBottom: '1rem', textAlign: center ? 'center' : 'left' }}>{children}</h2>
);

const GoldBar = ({ center = false }) => (
  <div style={{ width: '56px', height: '3px', borderRadius: '2px', background: 'linear-gradient(90deg, #D4AF37, #B9932F)', margin: center ? '0 auto 1.5rem' : '0 0 1.5rem', marginBottom: '1.5rem' }} />
);

const GoldDivider = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    <div style={{ flex: 1, height: '1px', background: 'linear-gradient(90deg, transparent, rgba(212,175,55,0.35))' }} />
    <div style={{ width: '5px', height: '5px', borderRadius: '50%', background: '#D4AF37' }} />
    <div style={{ width: '5px', height: '5px', borderRadius: '50%', background: 'rgba(212,175,55,0.4)' }} />
    <div style={{ width: '5px', height: '5px', borderRadius: '50%', background: '#D4AF37' }} />
    <div style={{ flex: 1, height: '1px', background: 'linear-gradient(90deg, rgba(212,175,55,0.35), transparent)' }} />
  </div>
);

/* â”€â”€ SVG Icons â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
const TempleIcon = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 21h18M5 21V10M19 21V10M12 3l3 5H9l3-5zM8 10V7h8v3M3 10h18"/>
  </svg>
);
const CommunityIcon = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
  </svg>
);
const GlobeIcon = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/>
  </svg>
);
const ScriptureIcon = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/>
    <path d="M8 7h8M8 11h6"/>
  </svg>
);
const ParticipateIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
  </svg>
);
const LearnIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/><path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/>
  </svg>
);
const ContributeIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
  </svg>
);
const ConnectIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
    <path d="M8.59 13.51l6.83 3.98M15.41 6.51L8.59 10.49"/>
  </svg>
);

const HomePage = () => {
  const [userCount, setUserCount] = useState(0);
  const [articleCount, setArticleCount] = useState(0);
  const [latestArticles, setLatestArticles] = useState([]);
  const [allArticles, setAllArticles] = useState([]);
  const [latestEvents, setLatestEvents] = useState([]);
  const [latestVideos, setLatestVideos] = useState([]);
  const [showArticlesModal, setShowArticlesModal] = useState(false);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_BASE_URL}/vrv-users-getAll`)
      .then(r => r.json())
      .then(data => {
        const parsed = typeof data.body === 'string' ? JSON.parse(data.body) : data;
        setUserCount((parsed.users || []).filter(u => u.role !== 'ADMIN' && u.role !== 'admin' && u.status === 'ACTIVE').length);
      }).catch(() => {});

    fetch(`${API_BASE_URL}/vrv-articlecontent-getAll`)
      .then(r => r.json())
      .then(data => {
        const parsed = typeof data.body === 'string' ? JSON.parse(data.body) : data;
        const approved = (parsed.data || []).filter(a => a.status === 'APPROVED' && a.visibility === 'PUBLIC');
        setArticleCount(approved.length);
        setAllArticles(approved);
        setLatestArticles(approved.slice(0, 5));
      }).catch(() => {});

    fetch(`${API_BASE_URL}/vrv-events-getAll`)
      .then(r => r.json())
      .then(data => {
        const parsed = typeof data.body === 'string' ? JSON.parse(data.body) : data;
        const now = new Date();
        const events = (parsed.data || parsed.events || [])
          .filter(e => (e.status === 'APPROVED' || e.visibility === 'PUBLIC') && e.event_start_date && new Date(e.event_start_date) > now)
          .sort((a, b) => new Date(a.event_start_date) - new Date(b.event_start_date))
          .slice(0, 1);
        setLatestEvents(events);
      }).catch(() => {});

    fetch(`${API_BASE_URL}/vrv-youtubecontent-getAll`)
      .then(r => r.json())
      .then(data => {
        const parsed = typeof data.body === 'string' ? JSON.parse(data.body) : data;
        const videos = (parsed.data || []).filter(v => v.status === 'APPROVED' || v.visibility === 'PUBLIC').slice(0, 1);
        setLatestVideos(videos);
      }).catch(() => {});
  }, []);

  const stats = [
    { icon: <TempleIcon />, value: '100+', label: 'Temples Connected' },
    { icon: <GlobeIcon />, value: '15+', label: 'Countries Reached' },
    { icon: <CommunityIcon />, value: userCount ? `${userCount}+` : '500+', label: 'Families Connected' },
    { icon: <ScriptureIcon />, value: articleCount || '0', label: 'Articles Published' },
  ];

  const platformFeatures = [
    {
      icon: <ParticipateIcon />, title: 'Participate',
      desc: 'Join spiritual events and community gatherings around the world.',
      cta: 'Explore Events →', link: '/events', guestLink: '/events'
    },
    {
      icon: <LearnIcon />, title: 'Learn',
      desc: 'Explore articles, teachings, and Vaikhanasa knowledge.',
      cta: 'Browse Articles →',
      isArticles: true,
      guestNote: isAuthenticated ? null : 'Sign in for full access'
    },
    {
      icon: <ContributeIcon />, title: 'Contribute',
      desc: 'Support community initiatives and preservation efforts.',
      cta: isAuthenticated ? 'Member Donations →' : 'Sign In to Donate →',
      link: isAuthenticated ? '/donate' : '/login', guestLink: '/login',
      guestNote: isAuthenticated ? null : 'Member access required'
    },
    {
      icon: <ConnectIcon />, title: 'Connect',
      desc: 'Engage with devotees, families, priests, and temples globally.',
      cta: isAuthenticated ? 'Community →' : 'Join Community →',
      link: isAuthenticated ? '/profile' : '/signup', guestLink: '/signup'
    },
  ];

  const regions = ['India', 'United States', 'United Kingdom', 'Australia', 'Singapore', 'Canada', 'Middle East'];

  const handleArticlesClick = (e) => {
    if (isAuthenticated) {
      navigate('/articles');
    } else {
      e.preventDefault();
      setShowArticlesModal(true);
    }
  };

  const ArticlesPreviewModal = () => (
    <AnimatePresence>
      {showArticlesModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 px-4"
          style={{ background: 'rgba(15,23,42,0.7)', backdropFilter: 'blur(6px)' }}
          onClick={() => setShowArticlesModal(false)}>
          <motion.div
            initial={{ scale: 0.92, opacity: 0, y: 16 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.92, opacity: 0, y: 16 }}
            transition={{ duration: 0.25 }}
            onClick={e => e.stopPropagation()}
            style={{ background: 'white', borderRadius: '24px', width: '100%', maxWidth: '480px', overflow: 'hidden', boxShadow: '0 24px 80px rgba(0,0,0,0.35)' }}>
            {/* Header */}
            <div style={{ background: 'linear-gradient(135deg, #16213E, #0F172A)', padding: '1.5rem 2rem', borderBottom: '1px solid rgba(212,175,55,0.2)', position: 'relative' }}>
              <div style={{ height: '2px', background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)', position: 'absolute', top: 0, left: 0, right: 0 }} />
              <p style={{ fontFamily: 'Poppins, sans-serif', fontSize: '0.62rem', fontWeight: 700, letterSpacing: '0.25em', textTransform: 'uppercase', color: 'rgba(212,175,55,0.7)', marginBottom: '0.3rem' }}>Community Knowledge</p>
              <h3 style={{ fontFamily: '"Cormorant Garamond", serif', fontSize: '1.6rem', fontWeight: 700, color: 'white', margin: 0 }}>Articles</h3>
              <button onClick={() => setShowArticlesModal(false)}
                style={{ position: 'absolute', top: '1.25rem', right: '1.5rem', background: 'rgba(255,255,255,0.08)', border: 'none', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', color: 'rgba(255,255,255,0.6)', fontSize: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                ×
              </button>
            </div>
            {/* Article list */}
            {/* Article list */}
            <div style={{ maxHeight: '340px', overflowY: 'auto' }}>
              {allArticles.length > 0 ? allArticles.map((a, i) => (
                <div key={i}
                  style={{ padding: '0.875rem 1.5rem', borderBottom: i < allArticles.length - 1 ? '1px solid rgba(15,23,42,0.06)' : 'none', display: 'flex', alignItems: 'flex-start', gap: '0.85rem', transition: 'background 0.15s', cursor: 'default' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#F8FAFC'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  <div style={{ flexShrink: 0, width: '30px', height: '30px', borderRadius: '8px', background: 'rgba(201,162,39,0.08)', border: '1px solid rgba(201,162,39,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#C9A227', marginTop: '2px' }}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                    </svg>
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.9375rem', fontWeight: 600, color: '#0F172A', lineHeight: 1.45, margin: 0, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{a.title}</p>
                    {a.createdAt && (
                      <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.72rem', color: '#94A3B8', marginTop: '0.2rem' }}>
                        {new Date(a.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                      </p>
                    )}
                  </div>
                </div>
              )) : (
                <div style={{ padding: '2.5rem', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{ width: '48px', height: '48px', borderRadius: '14px', background: 'rgba(201,162,39,0.08)', border: '1px solid rgba(201,162,39,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1rem', color: '#C9A227' }}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                    </svg>
                  </div>
                  <p style={{ fontFamily: 'Inter, sans-serif', color: '#64748B', fontSize: '0.9rem' }}>No articles available yet.</p>
                </div>
              )}
            </div>
            {/* CTA */}
            <div style={{ padding: '1.25rem 2rem', background: '#FDFBF7', borderTop: '1px solid rgba(212,175,55,0.1)', display: 'flex', flexDirection: 'column', gap: '0.75rem', alignItems: 'center' }}>
              <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.82rem', color: '#6B7280', textAlign: 'center' }}>
                Sign in to read full articles
              </p>
              <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
                <Link to="/login" onClick={() => setShowArticlesModal(false)}
                  style={{ fontFamily: 'Poppins, sans-serif', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'white', background: 'linear-gradient(135deg, #16213E, #0F172A)', padding: '0.6rem 1.5rem', borderRadius: '50px', textDecoration: 'none', border: '1px solid rgba(212,175,55,0.3)' }}>
                  Sign In
                </Link>
                <Link to="/signup" onClick={() => setShowArticlesModal(false)}
                  style={{ fontFamily: 'Poppins, sans-serif', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#0F172A', background: 'linear-gradient(135deg, #D4AF37, #B9932F)', padding: '0.6rem 1.5rem', borderRadius: '50px', textDecoration: 'none' }}>
                  Join Community
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );

  return (
    <div style={{ background: '#F8F5EE', color: '#111827' }} className="min-h-screen">
      <ArticlesPreviewModal />

      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          HERO BANNER — DO NOT MODIFY
      â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <section className="relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #0F172A 0%, #16213E 100%)', minHeight: '90vh', display: 'flex', alignItems: 'center' }}>
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse at 70% 40%, rgba(212,175,55,0.12) 0%, transparent 60%)' }} />
        <div className="absolute right-0 top-1/2 -translate-y-1/2 opacity-[0.03] pointer-events-none select-none text-white" style={{ fontSize: '40vw', fontFamily: '"Cormorant Garamond", serif', lineHeight: 1 }}>ॐ</div>
        <div className="vrv-container relative z-10 py-20">
          <div className="flex flex-col md:flex-row items-stretch gap-12">
            <motion.div className="flex-1" variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }} style={{ alignSelf: 'flex-start', paddingTop: '2.5rem' }}>
              <motion.h1 variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: false, amount: 0.3 }}
                className="text-5xl md:text-7xl font-bold leading-tight mb-6 text-white" style={{ fontFamily: 'Poppins, sans-serif' }}>
                VAIKHANASA{' '}
                <span style={{ background: 'linear-gradient(135deg, #D4AF37, #B9932F)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>RAKSHA</span><br />
                VAHINI
              </motion.h1>
              <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: false, amount: 0.3 }}
                className="text-lg max-w-lg mb-8 leading-relaxed" style={{ color: 'rgba(255,255,255,0.55)', fontFamily: 'Inter, sans-serif' }}>
                United in Devotion to Vishnu
              </motion.p>
              <motion.div variants={fadeUp} className="h-0.5 w-20 mb-8" style={{ background: 'linear-gradient(90deg, #D4AF37, transparent)' }} />
              <motion.div variants={fadeUp} className="flex flex-wrap gap-3">
                {!isAuthenticated && <Link to="/signup" className="btn-gold">Join the Community →</Link>}
                <Link to="/vaikhanasam" className="btn-outline" style={{ color: 'rgba(255,255,255,0.75)', borderColor: 'rgba(255,255,255,0.2)' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = '#D4AF37'; e.currentTarget.style.color = '#D4AF37'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'; e.currentTarget.style.color = 'rgba(255,255,255,0.75)'; }}>
                  Explore Vaikhanasam
                </Link>
              </motion.div>
            </motion.div>
            <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6, delay: 0.2 }}
              className="hidden md:flex flex-shrink-0 items-end justify-end" style={{ width: '720px', marginRight: '-3rem' }}>
              <img src="/images/Vishnu-Vikhanas.png" alt="Vishnu Vikhanas" className="w-full h-auto object-contain"
                style={{ maxHeight: '980px', mixBlendMode: 'screen', filter: 'drop-shadow(0 0 80px rgba(212,175,55,0.35))', marginBottom: '-2rem' }} />
            </motion.div>
          </div>
        </div>
      </section>

      {/* â”€â”€ SECTION 1: Community Impact â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <section style={{ background: 'white', borderBottom: '1px solid rgba(212,175,55,0.1)' }}>
        <div className="vrv-container">
          <motion.div initial="hidden" whileInView="show" viewport={{ once: true }} variants={stagger} className="grid grid-cols-2 md:grid-cols-4">
            {stats.map((stat, i) => (
              <motion.div key={i} variants={fadeUp}
                className="flex flex-col items-center py-12 px-4 text-center relative group cursor-default"
                style={{ borderRight: i < stats.length - 1 ? '1px solid rgba(212,175,55,0.1)' : 'none' }}
                whileHover={{ scale: 1.03 }}
                onMouseEnter={e => e.currentTarget.style.background = '#FDFBF7'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                <div className="absolute top-0 left-0 right-0 h-0.5 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-center"
                  style={{ background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)' }} />
                <div className="mb-4 transition-transform duration-300 group-hover:-translate-y-1" style={{ color: '#D4AF37' }}>{stat.icon}</div>
                <p style={{ fontFamily: '"Cormorant Garamond", serif', fontSize: 'clamp(2.2rem, 3vw, 3rem)', fontWeight: 700, color: '#16213E', lineHeight: 1, marginBottom: '0.5rem' }}>{stat.value}</p>
                <p style={{ fontFamily: 'Poppins, sans-serif', fontSize: '0.62rem', fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#9CA3AF' }}>{stat.label}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* â”€â”€ Divider â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <div className="vrv-container py-8"><GoldDivider /></div>

      {/* â”€â”€ SECTION 2: Our Purpose â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <section className="py-20" style={{ background: '#F8F5EE' }}>
        <div className="vrv-container">
          <motion.div initial="hidden" whileInView="show" viewport={{ once: true }} variants={stagger}
            className="flex flex-col lg:flex-row items-center gap-16">
            {/* Visual */}
            <motion.div variants={fadeUp} className="lg:w-5/12 w-full">
              <div className="relative rounded-3xl overflow-hidden" style={{ aspectRatio: '4/3', background: 'linear-gradient(135deg, #16213E, #0F172A)', border: '1px solid rgba(212,175,55,0.2)' }}>
                <div className="absolute inset-0 flex items-center justify-center" style={{ background: 'radial-gradient(ellipse at center, rgba(212,175,55,0.08) 0%, transparent 70%)' }}>
                  <div className="text-center px-8">
                    <div className="text-8xl mb-4 opacity-20 select-none" style={{ fontFamily: '"Cormorant Garamond", serif', color: '#D4AF37', lineHeight: 1 }}>ॐ</div>
                    <p style={{ fontFamily: '"Cormorant Garamond", serif', fontSize: '1.4rem', color: 'rgba(212,175,55,0.6)', fontStyle: 'italic' }}>
                      "Ancient in Origin,<br />Global in Reach"
                    </p>
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 h-1" style={{ background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)' }} />
              </div>
            </motion.div>
            {/* Text */}
            <motion.div variants={fadeUp} className="lg:w-7/12 w-full">
              <SectionLabel>Our Purpose</SectionLabel>
              <SectionHeading>
                Preserving Heritage.<br />
                Connecting Communities.<br />
                <span style={{ color: '#D4AF37', fontStyle: 'italic' }}>Inspiring Future Generations.</span>
              </SectionHeading>
              <GoldBar />
              <p style={{ color: '#6B7280', fontFamily: 'Inter, sans-serif', fontSize: '1.05rem', lineHeight: 1.85, marginBottom: '1.25rem', maxWidth: '520px' }}>
                For generations, Vaikhanasa families, priests, and devotees have safeguarded sacred traditions through worship, service, and knowledge.
              </p>
              <p style={{ color: '#6B7280', fontFamily: 'Inter, sans-serif', fontSize: '1.05rem', lineHeight: 1.85, marginBottom: '2rem', maxWidth: '520px' }}>
                This platform serves as a digital bridge connecting communities, sharing resources, supporting temples, and strengthening our heritage for future generations.
              </p>
              <Link to="/vaikhanasam" className="btn-navy" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                Explore Resources →
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* â”€â”€ Divider â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <div className="vrv-container py-4"><GoldDivider /></div>

      {/* â”€â”€ SECTION 3: Platform Features â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <section className="py-20" style={{ background: '#F8F5EE' }}>
        <div className="vrv-container">
          <motion.div initial="hidden" whileInView="show" viewport={{ once: true }} variants={stagger}>
            <motion.div variants={fadeUp} className="text-center mb-14">
              <SectionLabel>Platform Features</SectionLabel>
              <SectionHeading center>Everything You Need In One Place</SectionHeading>
              <GoldBar center />
              <p style={{ color: '#6B7280', fontFamily: 'Inter, sans-serif', fontSize: '1rem', lineHeight: 1.7, maxWidth: '480px', margin: '0 auto' }}>
                One platform. Every resource your community needs.
              </p>
            </motion.div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {platformFeatures.map((f, i) => (
                <motion.div key={i} variants={fadeUp}
                  whileHover={{ y: -8 }} transition={{ type: 'spring', stiffness: 300, damping: 20 }}
                  className="relative group cursor-pointer"
                  style={{ background: 'white', borderRadius: '20px', padding: '2rem', border: '1px solid rgba(212,175,55,0.12)', boxShadow: '0 2px 16px rgba(22,33,62,0.05)' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(212,175,55,0.4)'; e.currentTarget.style.boxShadow = '0 10px 40px rgba(22,33,62,0.1)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(212,175,55,0.12)'; e.currentTarget.style.boxShadow = '0 2px 16px rgba(22,33,62,0.05)'; }}>
                  <div className="absolute top-0 left-6 right-6 h-0.5 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-center rounded-full"
                    style={{ background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)' }} />
                  <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5"
                    style={{ background: 'linear-gradient(135deg, rgba(212,175,55,0.1), rgba(212,175,55,0.05))', border: '1px solid rgba(212,175,55,0.18)', color: '#D4AF37' }}>
                    {f.icon}
                  </div>
                  <h3 style={{ fontFamily: '"Cormorant Garamond", serif', fontSize: '1.4rem', fontWeight: 700, color: '#16213E', marginBottom: '0.5rem' }}>{f.title}</h3>
                  <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.88rem', color: '#6B7280', lineHeight: 1.7, marginBottom: '1.25rem' }}>{f.desc}</p>
                  {f.guestNote && (
                    <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.72rem', color: '#D4AF37', marginBottom: '0.75rem', fontStyle: 'italic' }}>{f.guestNote}</p>
                  )}
                  {f.isArticles ? (
                    <button onClick={handleArticlesClick}
                      style={{ fontFamily: 'Poppins, sans-serif', fontSize: '0.65rem', fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#D4AF37', background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                      onMouseEnter={e => e.currentTarget.style.color = '#B9932F'}
                      onMouseLeave={e => e.currentTarget.style.color = '#D4AF37'}>
                      {f.cta}
                    </button>
                  ) : (
                    <Link to={f.link} style={{ fontFamily: 'Poppins, sans-serif', fontSize: '0.65rem', fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#D4AF37', textDecoration: 'none' }}
                      onMouseEnter={e => e.currentTarget.style.color = '#B9932F'}
                      onMouseLeave={e => e.currentTarget.style.color = '#D4AF37'}>
                      {f.cta}
                    </Link>
                  )}
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* â”€â”€ IMAGE PLACEHOLDER â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
          Space freed by removing "Our Foundation" section.
          Approximate dimensions at full-width (1400px container):
            Desktop  → width: 100vw (max ~1400px), height: ~560px
            Tablet   → width: 100vw, height: ~480px
            Mobile   → width: 100vw, height: ~320px
          Background was: dark navy gradient (linear-gradient 135deg, #0F172A → #16213E)
          Padding was: py-20 (80px top + bottom) around a 4-column card grid.
          Drop your HD image here — recommended: 1920×560px or 1920×720px.
      â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}

      {/* â”€â”€ Divider â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}

      {/* ── VAIKHANASA LINEAGE IMAGE ───────────────────────────────────── */}
      <section style={{ position: 'relative', overflow: 'hidden', background: '#0F172A' }}>
        <img
          src="/images/VikhanasaLineage.png"
          alt="Vaikhanasa Lineage"
          style={{ width: '100%', display: 'block', objectFit: 'cover' }}
        />
      </section>

      <div className="vrv-container py-4"><GoldDivider /></div>

      {/* â”€â”€ SECTION 6: Global Community â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <section className="py-20" style={{ background: '#F8F5EE' }}>
        <div className="vrv-container">
          <motion.div initial="hidden" whileInView="show" viewport={{ once: true }} variants={stagger}>
            <motion.div variants={fadeUp} className="text-center mb-14">
              <SectionLabel>Worldwide Presence</SectionLabel>
              <SectionHeading center>Connecting Vaikhanasa Communities<br /><span style={{ color: '#D4AF37', fontStyle: 'italic' }}>Across Continents</span></SectionHeading>
              <GoldBar center />
              <p style={{ color: '#6B7280', fontFamily: 'Inter, sans-serif', fontSize: '1rem', lineHeight: 1.7, maxWidth: '500px', margin: '0 auto' }}>
                Connecting families, priests, temples, and devotees worldwide.
              </p>
            </motion.div>
            <motion.div variants={fadeUp} className="flex flex-wrap justify-center gap-3">
              {regions.map((region, i) => (
                <div key={i} className="group cursor-default"
                  style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '0.6rem 1.25rem', borderRadius: '50px', border: '1px solid rgba(212,175,55,0.2)', background: 'white', transition: 'border-color 0.3s, background 0.3s, transform 0.2s', boxShadow: '0 2px 8px rgba(22,33,62,0.04)' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = '#D4AF37'; e.currentTarget.style.background = 'rgba(212,175,55,0.04)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(212,175,55,0.2)'; e.currentTarget.style.background = 'white'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                  <GlobeIcon size={14} />
                  <span style={{ fontFamily: 'Poppins, sans-serif', fontSize: '0.78rem', fontWeight: 600, color: '#16213E' }}>{region}</span>
                </div>
              ))}
            </motion.div>
            <motion.p variants={fadeUp} className="text-center mt-8" style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.85rem', color: '#9CA3AF' }}>
              And growing every day...
            </motion.p>
          </motion.div>
        </div>
      </section>

      {/* â”€â”€ SECTION 5: Timeless Wisdom (Quote) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <section className="py-24 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #16213E, #0F172A)' }}>
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse at 50% 50%, rgba(212,175,55,0.06) 0%, transparent 70%)' }} />
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none opacity-[0.03]"
          style={{ fontFamily: '"Cormorant Garamond", serif', fontSize: '28rem', color: '#D4AF37', lineHeight: 1 }}>ॐ</div>
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}
          className="vrv-container text-center relative z-10">
          <div className="flex justify-center items-center gap-4 mb-8">
            <div style={{ width: '60px', height: '1px', background: 'rgba(212,175,55,0.3)' }} />
            <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#D4AF37' }} />
            <div style={{ width: '60px', height: '1px', background: 'rgba(212,175,55,0.3)' }} />
          </div>
          <SectionLabel light>Timeless Wisdom</SectionLabel>
          <blockquote style={{ fontFamily: '"Cormorant Garamond", serif', fontSize: 'clamp(1.7rem, 3.5vw, 3rem)', fontWeight: 600, fontStyle: 'italic', lineHeight: 1.55, color: 'rgba(255,255,255,0.88)', maxWidth: '820px', margin: '0 auto 2rem' }}>
            "Preserving tradition is not looking backward —<br />
            <span style={{ color: '#D4AF37' }}>it is carrying sacred wisdom forward."</span>
          </blockquote>
          <GoldDivider />
        </motion.div>
      </section>

      {/* ── SECTION 7: Community News & Resources ──────────────────── */}
      <section className="py-20" style={{ background: '#F8FAFC' }}>
        <div className="vrv-container">
          <motion.div initial="hidden" whileInView="show" viewport={{ once: true }} variants={stagger}>

            {/* Section header */}
            <motion.div variants={fadeUp} className="text-center" style={{ marginBottom: '3rem' }}>
              <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.875rem', fontWeight: 700, letterSpacing: '0.25em', textTransform: 'uppercase', color: '#C9A227', marginBottom: '0.75rem' }}>
                Latest Updates
              </p>
              <h2 style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(2.1rem, 4vw, 3.5rem)', fontWeight: 700, lineHeight: 1.15, color: '#0F172A', marginBottom: '1rem' }}>
                Community News &amp; Resources
              </h2>
              <div style={{ width: '52px', height: '3px', borderRadius: '2px', background: 'linear-gradient(90deg, #C9A227, #E6D39A)', margin: '0 auto' }} />
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" style={{ alignItems: 'stretch' }}>

              {/* ── UPCOMING EVENT CARD ── */}
              <motion.div variants={fadeUp} style={{ display: 'flex', flexDirection: 'column' }}>
                <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#C9A227', marginBottom: '0.85rem' }}>
                  Upcoming Event
                </p>
                {latestEvents.length > 0 ? latestEvents.map((ev, i) => (
                  <div key={i} style={{ background: '#fff', borderRadius: '24px', border: '1px solid rgba(15,23,42,0.08)', boxShadow: '0 4px 24px rgba(15,23,42,0.06)', overflow: 'hidden', display: 'flex', flexDirection: 'column', flex: 1, transition: 'transform 0.3s ease, box-shadow 0.3s ease' }}
                    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 12px 40px rgba(15,23,42,0.12)'; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(15,23,42,0.06)'; }}>
                    {/* Gold top accent */}
                    <div style={{ height: '3px', background: 'linear-gradient(90deg, #C9A227, #E6D39A)' }} />
                    <div style={{ flex: 1, padding: '1.75rem' }}>
                      {/* Calendar badge */}
                      <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', background: 'rgba(201,162,39,0.08)', border: '1px solid rgba(201,162,39,0.2)', borderRadius: '6px', padding: '0.3rem 0.65rem', marginBottom: '1rem' }}>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#C9A227" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                        </svg>
                        <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.65rem', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#C9A227' }}>
                          {ev.event_start_date ? new Date(ev.event_start_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'Upcoming'}
                        </span>
                      </div>
                      <h3 style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: '1.3rem', fontWeight: 700, color: '#0F172A', lineHeight: 1.35, marginBottom: '0' }}>{ev.title}</h3>
                    </div>
                    <div style={{ padding: '1rem 1.75rem', borderTop: '1px solid rgba(15,23,42,0.06)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Link to="/events" style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.08em', color: '#C9A227', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                        View Event
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                      </Link>
                    </div>
                  </div>
                )) : (
                  <div style={{ background: '#fff', borderRadius: '24px', border: '1px solid rgba(15,23,42,0.08)', boxShadow: '0 4px 24px rgba(15,23,42,0.06)', overflow: 'hidden', display: 'flex', flexDirection: 'column', flex: 1, transition: 'transform 0.3s ease, box-shadow 0.3s ease' }}
                    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 12px 40px rgba(15,23,42,0.12)'; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(15,23,42,0.06)'; }}>
                    <div style={{ height: '3px', background: 'linear-gradient(90deg, #C9A227, #E6D39A)' }} />
                    <div style={{ flex: 1, padding: '2.5rem 1.75rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                      <div style={{ width: '56px', height: '56px', borderRadius: '16px', background: 'rgba(201,162,39,0.08)', border: '1px solid rgba(201,162,39,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.25rem', color: '#C9A227' }}>
                        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                        </svg>
                      </div>
                      <h3 style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: '1.2rem', fontWeight: 700, color: '#0F172A', marginBottom: '0.6rem' }}>No Upcoming Events</h3>
                      <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.88rem', color: '#64748B', lineHeight: 1.7 }}>Upcoming community events and gatherings will appear here.</p>
                    </div>
                    <div style={{ padding: '1rem 1.75rem', borderTop: '1px solid rgba(15,23,42,0.06)' }}>
                      <Link to="/events" style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.08em', color: '#C9A227', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                        View All Events
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                      </Link>
                    </div>
                  </div>
                )}
              </motion.div>

              {/* ── LATEST ARTICLES CARD ── */}
              <motion.div variants={fadeUp} style={{ display: 'flex', flexDirection: 'column' }}>
                <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#C9A227', marginBottom: '0.85rem' }}>
                  Latest Articles
                </p>
                <div style={{ background: '#fff', borderRadius: '24px', border: '1px solid rgba(15,23,42,0.08)', boxShadow: '0 4px 24px rgba(15,23,42,0.06)', overflow: 'hidden', display: 'flex', flexDirection: 'column', flex: 1, transition: 'transform 0.3s ease, box-shadow 0.3s ease' }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 12px 40px rgba(15,23,42,0.12)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(15,23,42,0.06)'; }}>
                  <div style={{ height: '3px', background: 'linear-gradient(90deg, #0F172A, #1E293B)' }} />
                  <div style={{ flex: 1 }}>
                    {latestArticles.length > 0 ? latestArticles.map((a, i) => (
                      <div key={i} style={{ padding: '1rem 1.75rem', borderBottom: i < latestArticles.length - 1 ? '1px solid rgba(15,23,42,0.06)' : 'none', display: 'flex', alignItems: 'flex-start', gap: '0.85rem', transition: 'background 0.2s' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#F8FAFC'}
                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                        <div style={{ flexShrink: 0, width: '30px', height: '30px', borderRadius: '8px', background: 'rgba(201,162,39,0.08)', border: '1px solid rgba(201,162,39,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#C9A227', marginTop: '2px' }}>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                          </svg>
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <h4 style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.9375rem', fontWeight: 600, color: '#0F172A', lineHeight: 1.45, margin: 0, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{a.title}</h4>
                          {a.createdAt && (
                            <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.72rem', color: '#94A3B8', marginTop: '0.25rem' }}>
                              {new Date(a.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                            </p>
                          )}
                        </div>
                      </div>
                    )) : (
                      <div style={{ padding: '2.5rem 1.75rem', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1 }}>
                        <div style={{ width: '56px', height: '56px', borderRadius: '16px', background: 'rgba(201,162,39,0.08)', border: '1px solid rgba(201,162,39,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.25rem', color: '#C9A227' }}>
                          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                          </svg>
                        </div>
                        <p style={{ fontFamily: 'Inter, sans-serif', color: '#64748B', fontSize: '0.88rem' }}>No articles yet.</p>
                      </div>
                    )}
                  </div>
                  <div style={{ padding: '1rem 1.75rem', borderTop: '1px solid rgba(15,23,42,0.06)' }}>
                    {isAuthenticated ? (
                      <Link to="/articles" style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.08em', color: '#C9A227', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                        View All Articles
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                      </Link>
                    ) : (
                      <button onClick={() => setShowArticlesModal(true)}
                        style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.08em', color: '#C9A227', background: 'none', border: 'none', padding: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                        View All Articles
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                      </button>
                    )}
                  </div>
                </div>
              </motion.div>

              {/* ── LATEST VIDEO CARD ── */}
              <motion.div variants={fadeUp} style={{ display: 'flex', flexDirection: 'column' }}>
                <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#C9A227', marginBottom: '0.85rem' }}>
                  Latest Video
                </p>
                {latestVideos.length > 0 ? latestVideos.map((v, i) => {
                  const ytId = v.youtube_url ? v.youtube_url.replace('https://youtu.be/', '').split('?')[0] : null;
                  return (
                    <div key={i} style={{ background: '#fff', borderRadius: '24px', border: '1px solid rgba(15,23,42,0.08)', boxShadow: '0 4px 24px rgba(15,23,42,0.06)', overflow: 'hidden', display: 'flex', flexDirection: 'column', flex: 1, transition: 'transform 0.3s ease, box-shadow 0.3s ease' }}
                      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 12px 40px rgba(15,23,42,0.12)'; }}
                      onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(15,23,42,0.06)'; }}>
                      {ytId && (
                        <div style={{ position: 'relative', aspectRatio: '16/9', background: '#0F172A' }}>
                          <img src={`https://img.youtube.com/vi/${ytId}/mqdefault.jpg`} alt={v.title}
                            style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: isAuthenticated ? 1 : 0.65 }} />
                          {!isAuthenticated && (
                            <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'rgba(15,23,42,0.55)' }}>
                              <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: 'rgba(201,162,39,0.92)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '0.5rem' }}>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="#0F172A"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                              </div>
                              <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.65rem', fontWeight: 700, color: 'rgba(255,255,255,0.85)', letterSpacing: '0.12em', textTransform: 'uppercase' }}>Member Access</p>
                            </div>
                          )}
                          {isAuthenticated && (
                            <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: 0, transition: 'opacity 0.2s' }}
                              onMouseEnter={e => e.currentTarget.style.opacity = '1'}
                              onMouseLeave={e => e.currentTarget.style.opacity = '0'}>
                              <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: 'rgba(201,162,39,0.92)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="#0F172A"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      <div style={{ flex: 1, padding: '1.4rem 1.75rem 1rem' }}>
                        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', background: 'rgba(15,23,42,0.05)', borderRadius: '6px', padding: '0.25rem 0.6rem', marginBottom: '0.75rem' }}>
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                          <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.65rem', fontWeight: 600, color: '#64748B', letterSpacing: '0.08em', textTransform: 'uppercase' }}>{v.category || 'Spiritual Content'}</span>
                        </div>
                        <h4 style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: '1.1rem', fontWeight: 700, color: '#0F172A', lineHeight: 1.4, margin: 0 }}>{v.title}</h4>
                      </div>
                      <div style={{ padding: '1rem 1.75rem', borderTop: '1px solid rgba(15,23,42,0.06)' }}>
                        <Link to={isAuthenticated ? '/youtube' : '/login'} style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.08em', color: '#C9A227', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                          {isAuthenticated ? 'Watch Now' : 'Sign In to Watch'}
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                        </Link>
                      </div>
                    </div>
                  );
                }) : (
                  <div style={{ background: '#fff', borderRadius: '24px', border: '1px solid rgba(15,23,42,0.08)', boxShadow: '0 4px 24px rgba(15,23,42,0.06)', overflow: 'hidden', display: 'flex', flexDirection: 'column', flex: 1, transition: 'transform 0.3s ease, box-shadow 0.3s ease' }}
                    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 12px 40px rgba(15,23,42,0.12)'; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(15,23,42,0.06)'; }}>
                    <div style={{ height: '3px', background: 'linear-gradient(90deg, #C9A227, #E6D39A)' }} />
                    <div style={{ flex: 1, padding: '2.5rem 1.75rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                      <div style={{ width: '56px', height: '56px', borderRadius: '16px', background: 'rgba(201,162,39,0.08)', border: '1px solid rgba(201,162,39,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.25rem', color: '#C9A227' }}>
                        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                      </div>
                      <h3 style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: '1.2rem', fontWeight: 700, color: '#0F172A', marginBottom: '0.6rem' }}>Videos Coming Soon</h3>
                      <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.88rem', color: '#64748B', lineHeight: 1.7 }}>Spiritual content and community videos will appear here.</p>
                    </div>
                    <div style={{ padding: '1rem 1.75rem', borderTop: '1px solid rgba(15,23,42,0.06)' }}>
                      <Link to="/youtube" style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.08em', color: '#C9A227', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                        Browse Videos
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                      </Link>
                    </div>
                  </div>
                )}
              </motion.div>

            </div>
          </motion.div>
        </div>
      </section>

      {/* â”€â”€ SECTION 8: Community Invitation (CTA) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <section className="py-24 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #0F172A 0%, #16213E 100%)' }}>
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse at 50% 50%, rgba(212,175,55,0.08) 0%, transparent 65%)' }} />
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
          className="vrv-container text-center relative z-10 max-w-2xl mx-auto">
          <SectionLabel light>Join Us</SectionLabel>
          <h2 style={{ fontFamily: '"Cormorant Garamond", "Playfair Display", serif', fontSize: 'clamp(2.2rem, 5vw, 3.5rem)', fontWeight: 700, lineHeight: 1.2, color: 'white', marginBottom: '1.5rem' }}>
            Join the Global<br />
            <span style={{ background: 'linear-gradient(135deg, #D4AF37, #B9932F)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
              Vaikhanasa Community
            </span>
          </h2>
          <div style={{ width: '56px', height: '2px', background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)', margin: '0 auto 1.5rem' }} />
          <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '1.05rem', color: 'rgba(255,255,255,0.55)', lineHeight: 1.8, marginBottom: '2.5rem', maxWidth: '480px', margin: '0 auto 2.5rem' }}>
            Together we preserve tradition, share knowledge, strengthen communities, and inspire future generations.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            {!isAuthenticated && (
              <Link to="/signup" className="btn-gold" style={{ fontSize: '0.85rem', padding: '0.85rem 2rem' }}>
                Become a Member →
              </Link>
            )}
            {isAuthenticated && (
              <Link to="/donate" className="btn-outline" style={{ color: 'rgba(255,255,255,0.75)', borderColor: 'rgba(255,255,255,0.2)', fontSize: '0.85rem', padding: '0.85rem 2rem' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = '#D4AF37'; e.currentTarget.style.color = '#D4AF37'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'; e.currentTarget.style.color = 'rgba(255,255,255,0.75)'; }}>
                Support the Mission
              </Link>
            )}
          </div>
        </motion.div>
      </section>

    </div>
  );
};

export default HomePage;
